import { render, staticRenderFns } from "./layanan.vue?vue&type=template&id=6394c3f0&"
import script from "./layanan.vue?vue&type=script&lang=js&"
export * from "./layanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports